import { useMemo } from 'react';
import Particles from '@tsparticles/react';

const ParticlesBackground = () => {
  const options = useMemo(
    () => ({
      preset: 'stars',
      fullScreen: {
        enable: true,
        zIndex: 0,
      },
      background: {
        color: '#000000',
      },
    }),
    []
  );

  return <Particles id="tsparticles" options={options} />;
};

export default ParticlesBackground;
